import { render } from "./BreadcrumbProductDetail.vue?vue&type=template&id=ca7ff7e6&scoped=true"
import script from "./BreadcrumbProductDetail.vue?vue&type=script&lang=js"
export * from "./BreadcrumbProductDetail.vue?vue&type=script&lang=js"

import "./BreadcrumbProductDetail.vue?vue&type=style&index=0&id=ca7ff7e6&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7ff7e6"]])

export default __exports__